import { getSignedUrl } from "@/shared/requests/get-signed-url";

const urlMap = new Map<string, string>(); // create a map and store the signed URL to avoid getting signed URL on every click

// Before rendering source, check and refresh URL if needed
export const checkAndRefreshUrl = async (url: string, fileName?: string): Promise<string> => {
  try {
    if (url.startsWith("https://publicassetszania.blob.core.windows.net/")) {
      return url;
    }
    if (fileName && !urlMap.has(fileName)) {
      urlMap.set(fileName, url);
    }

    const updatedUrl = fileName ? (urlMap.get(fileName) || url) : url;
    const expiryDate = new URL(updatedUrl).searchParams.get("se");

    if (expiryDate) {
      // if it is a signed url, with the query params intact
      const expiry = new Date(expiryDate);
      const currentTime = new Date();
      const diff = expiry.getTime() - currentTime.getTime();

      // Refresh if URL is valid for more than 5 mins
      if (diff > 300000) {

        return updatedUrl;
      }
    }
    const signedUrl = await getSignedUrl({
      stale_urls: [updatedUrl],
      max_age: 86400,
    });
    if (fileName) {
      urlMap.set(fileName, signedUrl[0]);
    }
    return signedUrl[0];
  } catch (error) {
    console.error("Error refreshing URL:", error);
    return url;
  }
};